export const buttonStyle = (role: string) => {
  const standardized = role.toLowerCase();
  let styles = ``;
  if (standardized === "assistant" || standardized === "model") {
    styles += `bg-gray-100 text-gray-800`;
  } else {
    styles += `bg-white text-gray-600`;
  }
  return styles;
};
